module.exports = __webpack_public_path__ + "img/model-icon.ae2ebf54.svg";